<script lang="ts">
	import PageListCard from '$lib/components/PageListCard.svelte';
	import type { Content } from '@prismicio/client';
	import type { SliceComponentProps } from '@prismicio/svelte';

	type Props = SliceComponentProps<Content.PageListSlice>;

	const { slice }: Props = $props();
	const columns = 12 / (slice.primary.desktop_columns ?? 2);
</script>

<section
	class="page-list spacing-top-{slice.primary.spacing_top} spacing-bottom-{slice.primary
		.spacing_bottom}"
	data-slice-type={slice.slice_type}
	data-slice-variation={slice.variation}
>
	<div class="container">
		<div class="row gy-5 align-items-stretch">
			{#each slice.primary.pages as page}
				<div class="col-12 col-lg-{columns}">
					<PageListCard {page} />
				</div>
			{/each}
		</div>
	</div>
</section>
